<div class="dashboard-toolbar">
  <div class="dashboard-toolbar__lead">
    <div class="dashboard-toolbar__icon" aria-hidden="true">
      <mat-icon>bar_chart</mat-icon>
    </div>
    <div>
      <div class="dashboard-toolbar__title">{{ 'liveDashboard.title' | translate }}</div>
      <div class="dashboard-toolbar__meta">
        <span
          class="dashboard-toolbar__pulse"
          role="img"
          [attr.aria-label]="'liveDashboard.liveIndicator' | translate"
        ></span>
        <span>{{ username() }} · {{ viewLabelKey() | translate }}</span>
      </div>
    </div>
  </div>

  <div class="dashboard-toolbar__controls">
    <app-projekt-filter
      [projects]="projects()"
      [colorOrder]="colorOrder()"
      [selected]="selectedProjectIds()"
      [state]="projectsState()"
      (selectedChange)="projectIdsChange.emit($event)"
    />
    <div class="dashboard-toolbar__range" data-testid="dash-zeitraum">
      <mat-icon class="dashboard-toolbar__range-icon" aria-hidden="true">bar_chart</mat-icon>
      <label class="dashboard-toolbar__visually-hidden" for="dashboard-von">
        {{ 'liveDashboard.von' | translate }}
      </label>
      <input
        id="dashboard-von"
        class="dashboard-toolbar__date"
        type="date"
        [value]="von()"
        [attr.max]="bis()"
        [attr.aria-label]="'liveDashboard.von' | translate"
        (change)="onVonInput($any($event.target).value)"
      />
      <span class="dashboard-toolbar__sep" aria-hidden="true">–</span>
      <label class="dashboard-toolbar__visually-hidden" for="dashboard-bis">
        {{ 'liveDashboard.bis' | translate }}
      </label>
      <input
        id="dashboard-bis"
        class="dashboard-toolbar__date"
        type="date"
        [value]="bis()"
        [attr.min]="von()"
        [attr.aria-label]="'liveDashboard.bis' | translate"
        (change)="onBisInput($any($event.target).value)"
      />
    </div>

    <button
      type="button"
      class="dashboard-toolbar__customize"
      data-testid="dash-anpassen"
      aria-haspopup="dialog"
      [class.dashboard-toolbar__customize--active]="configOpen()"
      [attr.aria-expanded]="configOpen()"
      [attr.aria-label]="'liveDashboard.anpassen' | translate"
      (click)="$event.stopPropagation(); onToggleConfig()"
    >
      <mat-icon aria-hidden="true">settings</mat-icon>
      <span>{{ 'liveDashboard.anpassen' | translate }}</span>
    </button>

    @if (configOpen() && config(); as cfg) {
      <app-dashboard-config-panel
        [config]="cfg"
        [username]="username()"
        (sectionToggle)="onSectionToggle($event)"
        (resetToDefault)="onResetToDefault()"
        (closePanel)="onCloseConfig()"
      />
    }
  </div>

  @if (rangeError(); as error) {
    <div class="dashboard-toolbar__error" role="alert">{{ error | translate }}</div>
  }
</div>
